import { useLocation, useNavigate } from "react-router-dom";
import { useLang, toggledPath } from "@/lib/i18n";

export const LanguageSwitcher = () => {
  const { lang } = useLang();
  const location = useLocation();
  const navigate = useNavigate();

  const go = (target) => {
    if (target === lang) return;
    navigate(toggledPath(location.pathname));
  };

  const base = "px-2.5 py-1 text-sm font-semibold rounded-md transition-all";
  return (
    <div
      className="flex items-center gap-0.5 rounded-lg bg-white/5 border border-white/10 p-0.5"
      data-testid="language-switcher"
    >
      <button
        type="button"
        onClick={() => go("en")}
        data-testid="lang-en-btn"
        className={`${base} ${lang === "en" ? "bg-[#FFEA00] text-black" : "text-white/60 hover:text-white"}`}
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => go("ru")}
        data-testid="lang-ru-btn"
        className={`${base} ${lang === "ru" ? "bg-[#FFEA00] text-black" : "text-white/60 hover:text-white"}`}
      >
        RU
      </button>
    </div>
  );
};
